"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPassword = exports.NewPassword = exports.Logout = exports.ValidateUser = exports.Me = exports.Register = exports.Login = exports.UpdateField = exports.UpdatePartially = exports.GetQueryParameters = exports.RunQuery = exports.GetQueryCode = exports.ListThisQueryResources = exports.CreateQuery = exports.ListQueryResources = exports.AdhocCountQueryPOST = exports.AdhocCountQuery = exports.AdhocQueryPOST = exports.AdhocQuery = exports.DeleteSchema = exports.ReplaceSchema = exports.UpdateSchema = exports.GetSchema = exports.ReplaceAllSchemas = exports.UpdateAllSchemas = exports.GetAllSchemas = exports.DeleteObject = exports.ReplaceObject = exports.GetObject = exports.CreateObject = exports.TruncateBucket = exports.ImportBucket = exports.ExportBucket = exports.GetBucketIds = exports.GetBucketNames = exports.UnbanIp = exports.Unban = exports.Banned = exports.BannedIp = exports.Status = exports.ConnectViaPost = exports.Connect = exports.UpdateOrestesConfig = exports.GetOrestesConfig = exports.DeleteBloomFilter = exports.GetBloomFilterExpirations = exports.GetBloomFilter = exports.Specification = exports.ApiVersion = exports.ListAllResources = void 0;
exports.VAPIDKeys = exports.DeviceRegistered = exports.DevicePush = exports.DeviceRegister = exports.DropAllIndexes = exports.CreateDropIndex = exports.ListIndexes = exports.CleanUpStorage = exports.CleanUpAssets = exports.GetAllRevalidationStatus = exports.CancelRevalidation = exports.GetRevalidationStatus = exports.EditRevalidationJob = exports.RevalidateAssets = exports.DownloadAsset = exports.CreateManifest = exports.DeleteFile = exports.UpdateFileMetadata = exports.GetFileMetadata = exports.UploadFile = exports.DownloadFile = exports.CreateFile = exports.DeleteFileBucket = exports.SetFileBucketMetadata = exports.GetFileBucketMetadata = exports.UploadPatchArchive = exports.DownloadArchive = exports.ListBuckets = exports.ListFiles = exports.GetAllCodeContent = exports.GetAllModules = exports.GetBaqendModule = exports.PostBaqendModule = exports.DeleteBaqendCode = exports.SetBaqendCode = exports.GetBaqendCode = exports.AssumeRole = exports.MFAStatus = exports.MFADelete = exports.MFAToken = exports.MFAInitFinish = exports.MFAInitChallenge = exports.RevokeUserToken = exports.UserToken = exports.DeletePassword = exports.OAuth1 = exports.OAuth2 = exports.VerifyUsername = exports.ChangeUsername = exports.Verify = void 0;
exports.Startup = exports.Live = exports.Ready = exports.Mail = exports.DeactivateTestingInstallationById = exports.GetAllDomains = exports.FindSpecificInstallation = exports.ActivateInstallationById = exports.ActivateInstallationByDomainAndConfigVersion = exports.CloneInstallationById = exports.CloneInstallationByDomainAndConfigVersion = exports.UpdateInstallationById = exports.UpdateInstallationByDomainAndConfigVersion = exports.CreateNewInstallation = exports.GetInstallationById = exports.ConfigAPI = exports.UploadAPNSCertificate = exports.GCMAKey = exports.VAPIDPublicKey = void 0;
/* DO NOT TOUCH THIS AUTO-GENERATED FILE */
/* eslint-disable max-len,@typescript-eslint/no-redeclare */
var connector_1 = require("./connector");
exports.ListAllResources = connector_1.Message.create({
    method: 'GET',
    path: '/',
    status: [200],
});
exports.ApiVersion = connector_1.Message.create({
    method: 'GET',
    path: '/version',
    status: [200],
});
exports.Specification = connector_1.Message.create({
    method: 'GET',
    path: '/spec',
    status: [200],
});
exports.GetBloomFilter = connector_1.Message.create({
    method: 'GET',
    path: '/bloomfilter?rules=false',
    status: [200],
});
exports.GetBloomFilterExpirations = connector_1.Message.create({
    method: 'GET',
    path: '/bloomfilter/expirations',
    status: [200],
});
exports.DeleteBloomFilter = connector_1.Message.create({
    method: 'DELETE',
    path: '/bloomfilter?flush=true',
    status: [204],
});
exports.GetOrestesConfig = connector_1.Message.create({
    method: 'GET',
    path: '/config',
    status: [200],
});
exports.UpdateOrestesConfig = connector_1.Message.create({
    method: 'PUT',
    path: '/config',
    status: [200, 202],
});
exports.Connect = connector_1.Message.create({
    method: 'GET',
    path: '/connect',
    status: [200],
});
exports.ConnectViaPost = connector_1.Message.create({
    method: 'POST',
    path: '/connect',
    status: [200],
});
exports.Status = connector_1.Message.create({
    method: 'GET',
    path: '/status',
    status: [200],
});
exports.BannedIp = connector_1.Message.create({
    method: 'GET',
    path: '/banned/:ip',
    status: [204],
});
exports.Banned = connector_1.Message.create({
    method: 'GET',
    path: '/banned',
    status: [],
});
exports.Unban = connector_1.Message.create({
    method: 'DELETE',
    path: '/banned',
    status: [204],
});
exports.UnbanIp = connector_1.Message.create({
    method: 'DELETE',
    path: '/banned/:ip',
    status: [204],
});
exports.GetBucketNames = connector_1.Message.create({
    method: 'GET',
    path: '/db',
    status: [200],
});
exports.GetBucketIds = connector_1.Message.create({
    method: 'GET',
    path: '/db/:bucket/ids?start=0&count=-1',
    status: [200],
});
exports.ExportBucket = connector_1.Message.create({
    method: 'GET',
    path: '/db/:bucket',
    status: [200],
});
exports.ImportBucket = connector_1.Message.create({
    method: 'PUT',
    path: '/db/:bucket',
    status: [200],
});
exports.TruncateBucket = connector_1.Message.create({
    method: 'DELETE',
    path: '/db/:bucket',
    status: [200],
});
exports.CreateObject = connector_1.Message.create({
    method: 'POST',
    path: '/db/:bucket',
    status: [201, 202],
});
exports.GetObject = connector_1.Message.create({
    method: 'GET',
    path: '/db/:bucket/:oid',
    status: [200, 304],
});
exports.ReplaceObject = connector_1.Message.create({
    method: 'PUT',
    path: '/db/:bucket/:oid',
    status: [200, 202],
});
exports.DeleteObject = connector_1.Message.create({
    method: 'DELETE',
    path: '/db/:bucket/:oid',
    status: [202, 204],
});
exports.GetAllSchemas = connector_1.Message.create({
    method: 'GET',
    path: '/schema',
    status: [200],
});
exports.UpdateAllSchemas = connector_1.Message.create({
    method: 'POST',
    path: '/schema',
    status: [200],
});
exports.ReplaceAllSchemas = connector_1.Message.create({
    method: 'PUT',
    path: '/schema',
    status: [200],
});
exports.GetSchema = connector_1.Message.create({
    method: 'GET',
    path: '/schema/:bucket',
    status: [200],
});
exports.UpdateSchema = connector_1.Message.create({
    method: 'POST',
    path: '/schema/:bucket',
    status: [200],
});
exports.ReplaceSchema = connector_1.Message.create({
    method: 'PUT',
    path: '/schema/:bucket',
    status: [200],
});
exports.DeleteSchema = connector_1.Message.create({
    method: 'DELETE',
    path: '/schema/:bucket',
    status: [204],
});
exports.AdhocQuery = connector_1.Message.create({
    method: 'GET',
    path: '/db/:bucket/query?q&start=0&count=-1&sort=&eager=&hinted=&triggeredBy=&ttl=',
    status: [200],
});
exports.AdhocQueryPOST = connector_1.Message.create({
    method: 'POST',
    path: '/db/:bucket/query?start=0&count=-1&sort=&triggeredBy=&ttl=',
    status: [200],
});
exports.AdhocCountQuery = connector_1.Message.create({
    method: 'GET',
    path: '/db/:bucket/count?q',
    status: [200],
});
exports.AdhocCountQueryPOST = connector_1.Message.create({
    method: 'POST',
    path: '/db/:bucket/count',
    status: [200],
});
exports.ListQueryResources = connector_1.Message.create({
    method: 'GET',
    path: '/query',
    status: [200],
});
exports.CreateQuery = connector_1.Message.create({
    method: 'POST',
    path: '/query',
    status: [201],
});
exports.ListThisQueryResources = connector_1.Message.create({
    method: 'GET',
    path: '/query/:qid',
    status: [200],
});
exports.GetQueryCode = connector_1.Message.create({
    method: 'GET',
    path: '/query/:qid/source',
    status: [200],
});
exports.RunQuery = connector_1.Message.create({
    method: 'GET',
    path: '/query/:qid/result?start=0&count=-1',
    status: [200],
});
exports.GetQueryParameters = connector_1.Message.create({
    method: 'GET',
    path: '/query/:qid/parameters',
    status: [200],
});
exports.UpdatePartially = connector_1.Message.create({
    method: 'POST',
    path: '/db/:bucket/:oid',
    status: [200],
});
exports.UpdateField = connector_1.Message.create({
    method: 'POST',
    path: '/db/:bucket/:oid/:field',
    status: [200],
});
exports.Login = connector_1.Message.create({
    method: 'POST',
    path: '/db/User/login',
    status: [200],
});
exports.Register = connector_1.Message.create({
    method: 'POST',
    path: '/db/User/register',
    status: [200, 204],
});
exports.Me = connector_1.Message.create({
    method: 'GET',
    path: '/db/User/me',
    status: [200],
});
exports.ValidateUser = connector_1.Message.create({
    method: 'GET',
    path: '/db/User/validate',
    status: [200],
});
exports.Logout = connector_1.Message.create({
    method: 'GET',
    path: '/db/User/logout',
    status: [204],
});
exports.NewPassword = connector_1.Message.create({
    method: 'POST',
    path: '/db/User/password',
    status: [200],
});
exports.ResetPassword = connector_1.Message.create({
    method: 'POST',
    path: '/db/User/reset',
    status: [200],
});
exports.Verify = connector_1.Message.create({
    method: 'GET',
    path: '/db/User/verify?token=',
    status: [204],
});
exports.ChangeUsername = connector_1.Message.create({
    method: 'POST',
    path: '/db/User/changeUsername',
    status: [204],
});
exports.VerifyUsername = connector_1.Message.create({
    method: 'GET',
    path: '/db/User/verifyUsername?token=',
    status: [204],
});
exports.OAuth2 = connector_1.Message.create({
    method: 'GET',
    path: '/db/User/OAuth/:provider?state=&code=&oauth_verifier=&oauth_token=&error_description=',
    status: [200],
});
exports.OAuth1 = connector_1.Message.create({
    method: 'GET',
    path: '/db/User/OAuth1/:provider',
    status: [200],
});
exports.DeletePassword = connector_1.Message.create({
    method: 'DELETE',
    path: '/db/User/password',
    status: [204],
});
exports.UserToken = connector_1.Message.create({
    method: 'POST',
    path: '/db/User/:oid/token',
    status: [200],
});
exports.RevokeUserToken = connector_1.Message.create({
    method: 'DELETE',
    path: '/db/User/:oid/token',
    status: [204],
});
exports.MFAInitChallenge = connector_1.Message.create({
    method: 'GET',
    path: '/db/User/mfa/init',
    status: [200],
});
exports.MFAInitFinish = connector_1.Message.create({
    method: 'POST',
    path: '/db/User/mfa/init',
    status: [200],
});
exports.MFAToken = connector_1.Message.create({
    method: 'POST',
    path: '/db/User/mfa/token',
    status: [200],
});
exports.MFADelete = connector_1.Message.create({
    method: 'DELETE',
    path: '/db/User/mfa',
    status: [204],
});
exports.MFAStatus = connector_1.Message.create({
    method: 'GET',
    path: '/db/User/mfa/status',
    status: [200],
});
exports.AssumeRole = connector_1.Message.create({
    method: 'POST',
    path: '/db/Role/:oid/assume',
    status: [200],
});
exports.GetBaqendCode = connector_1.Message.create({
    method: 'GET',
    path: '/code/:bucket/:type',
    status: [200],
});
exports.SetBaqendCode = connector_1.Message.create({
    method: 'PUT',
    path: '/code/:bucket/:type',
    status: [200, 202],
});
exports.DeleteBaqendCode = connector_1.Message.create({
    method: 'DELETE',
    path: '/code/:bucket/:type',
    status: [202, 204],
});
exports.PostBaqendModule = connector_1.Message.create({
    method: 'POST',
    path: '/code/:bucket',
    status: [200, 204],
});
exports.GetBaqendModule = connector_1.Message.create({
    method: 'GET',
    path: '/code/:bucket',
    status: [200, 204],
});
exports.GetAllModules = connector_1.Message.create({
    method: 'GET',
    path: '/code',
    status: [200],
});
exports.GetAllCodeContent = connector_1.Message.create({
    method: 'GET',
    path: '/code-content',
    status: [200],
});
exports.ListFiles = connector_1.Message.create({
    method: 'GET',
    path: '/file/:bucket/ids?path=/&start=&count=-1&deep=false',
    status: [200],
});
exports.ListBuckets = connector_1.Message.create({
    method: 'GET',
    path: '/file/buckets',
    status: [200],
});
exports.DownloadArchive = connector_1.Message.create({
    method: 'GET',
    path: '/file',
    status: [200],
});
exports.UploadPatchArchive = connector_1.Message.create({
    method: 'POST',
    path: '/file',
    status: [200],
});
exports.GetFileBucketMetadata = connector_1.Message.create({
    method: 'GET',
    path: '/file/:bucket',
    status: [200],
});
exports.SetFileBucketMetadata = connector_1.Message.create({
    method: 'PUT',
    path: '/file/:bucket',
    status: [204],
});
exports.DeleteFileBucket = connector_1.Message.create({
    method: 'DELETE',
    path: '/file/:bucket',
    status: [204],
});
exports.CreateFile = connector_1.Message.create({
    method: 'POST',
    path: '/file/:bucket',
    status: [200],
});
exports.DownloadFile = connector_1.Message.create({
    method: 'GET',
    path: '/file/:bucket/*oid',
    status: [200, 304],
});
exports.UploadFile = connector_1.Message.create({
    method: 'PUT',
    path: '/file/:bucket/*oid',
    status: [200],
});
exports.GetFileMetadata = connector_1.Message.create({
    method: 'HEAD',
    path: '/file/:bucket/*oid',
    status: [200],
});
exports.UpdateFileMetadata = connector_1.Message.create({
    method: 'POST',
    path: '/file/:bucket/*oid',
    status: [200],
});
exports.DeleteFile = connector_1.Message.create({
    method: 'DELETE',
    path: '/file/:bucket/*oid',
    status: [200, 204],
});
exports.CreateManifest = connector_1.Message.create({
    method: 'POST',
    path: '/pwa/manifest',
    status: [202],
});
exports.DownloadAsset = connector_1.Message.create({
    method: 'GET',
    path: '/asset/*url',
    status: [200, 304],
});
exports.RevalidateAssets = connector_1.Message.create({
    method: 'POST',
    path: '/asset/revalidate',
    status: [202],
});
exports.EditRevalidationJob = connector_1.Message.create({
    method: 'POST',
    path: '/asset/revalidate/:id',
    status: [204],
});
exports.GetRevalidationStatus = connector_1.Message.create({
    method: 'GET',
    path: '/asset/revalidate/:id',
    status: [200, 202],
});
exports.CancelRevalidation = connector_1.Message.create({
    method: 'DELETE',
    path: '/asset/revalidate/:id',
    status: [202],
});
exports.GetAllRevalidationStatus = connector_1.Message.create({
    method: 'GET',
    path: '/asset/revalidate?state=',
    status: [200],
});
exports.CleanUpAssets = connector_1.Message.create({
    method: 'POST',
    path: '/asset/cleanup',
    status: [202],
});
exports.CleanUpStorage = connector_1.Message.create({
    method: 'POST',
    path: '/asset/cleanup/storage',
    status: [202],
});
exports.ListIndexes = connector_1.Message.create({
    method: 'GET',
    path: '/index/:bucket',
    status: [200],
});
exports.CreateDropIndex = connector_1.Message.create({
    method: 'POST',
    path: '/index/:bucket',
    status: [202],
});
exports.DropAllIndexes = connector_1.Message.create({
    method: 'DELETE',
    path: '/index/:bucket',
    status: [202],
});
exports.DeviceRegister = connector_1.Message.create({
    method: 'POST',
    path: '/db/Device/register',
    status: [200],
});
exports.DevicePush = connector_1.Message.create({
    method: 'POST',
    path: '/db/Device/push',
    status: [204],
});
exports.DeviceRegistered = connector_1.Message.create({
    method: 'GET',
    path: '/db/Device/registered',
    status: [200],
});
exports.VAPIDKeys = connector_1.Message.create({
    method: 'POST',
    path: '/config/VAPIDKeys',
    status: [200],
});
exports.VAPIDPublicKey = connector_1.Message.create({
    method: 'GET',
    path: '/config/VAPIDPublicKey',
    status: [200],
});
exports.GCMAKey = connector_1.Message.create({
    method: 'POST',
    path: '/config/GCMKey',
    status: [204],
});
exports.UploadAPNSCertificate = connector_1.Message.create({
    method: 'POST',
    path: '/config/APNSCert',
    status: [204],
});
exports.ConfigAPI = connector_1.Message.create({
    method: 'GET',
    path: '/speedkit/installation/:domain/:configVersion',
    status: [200],
});
exports.GetInstallationById = connector_1.Message.create({
    method: 'GET',
    path: '/speedkit/installation/:id',
    status: [200],
});
exports.CreateNewInstallation = connector_1.Message.create({
    method: 'POST',
    path: '/speedkit/installation/:domain',
    status: [200],
});
exports.UpdateInstallationByDomainAndConfigVersion = connector_1.Message.create({
    method: 'PUT',
    path: '/speedkit/installation/:domain/:configVersion',
    status: [200],
});
exports.UpdateInstallationById = connector_1.Message.create({
    method: 'PUT',
    path: '/speedkit/installation/:id',
    status: [200],
});
exports.CloneInstallationByDomainAndConfigVersion = connector_1.Message.create({
    method: 'POST',
    path: '/speedkit/installation/:domain/:configVersion/clone',
    status: [200],
});
exports.CloneInstallationById = connector_1.Message.create({
    method: 'POST',
    path: '/speedkit/installation/:id/clone',
    status: [200],
});
exports.ActivateInstallationByDomainAndConfigVersion = connector_1.Message.create({
    method: 'POST',
    path: '/speedkit/installation/:domain/:configVersion/activate?testing=',
    status: [200],
});
exports.ActivateInstallationById = connector_1.Message.create({
    method: 'POST',
    path: '/speedkit/installation/:id/activate?testing=',
    status: [200],
});
exports.FindSpecificInstallation = connector_1.Message.create({
    method: 'GET',
    path: '/speedkit/installation?domain=&status=&start=0&count=-1',
    status: [200],
});
exports.GetAllDomains = connector_1.Message.create({
    method: 'GET',
    path: '/speedkit/installation/domain',
    status: [200],
});
exports.DeactivateTestingInstallationById = connector_1.Message.create({
    method: 'PUT',
    path: '/speedkit/installation/:id/deactivate?force=',
    status: [200],
});
exports.Mail = connector_1.Message.create({
    method: 'POST',
    path: '/mail',
    status: [200],
});
exports.Ready = connector_1.Message.create({
    method: 'GET',
    path: '/-/ready',
    status: [200],
});
exports.Live = connector_1.Message.create({
    method: 'GET',
    path: '/-/live',
    status: [200],
});
exports.Startup = connector_1.Message.create({
    method: 'GET',
    path: '/-/startup',
    status: [200],
});
//# sourceMappingURL=data:application/json;base64,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